import React from 'react'
import PropTypes from 'prop-types'
import Slide from './Slide'
import Disclaimer from './Disclaimer'
import './SplitSlide.css'
import Transition from 'react-transition-group/Transition'
import { connect } from 'react-redux'


class SplitSlideReverse extends Slide {

    renderMobile() {

        const defaultStyles = (duration, delay = 300) => ({
            transition: `opacity ${duration}ms ${delay}ms ease-in`
        })

        const transitionStyles = {
            entering: { opacity: 0 },
            entered: { opacity: 1 },
            exiting: { opacity: 1 },
            exited: { opacity: 0 }
        }

        return super.render(
            <Transition in={this.props.in} timeout={0}>
                { state => (
                    <div className='SplitSlide' style={{background: `url(${this.props.background})`}}>
                        <div className='SplitSlide-Info-Mobile'>
                            <div className='SplitSlide-Desc' style={{...defaultStyles(300, 2000), ...transitionStyles[state]}}>
                                <span><b>{ this.props.desc.caption }</b></span>
                                <br/>
                                <span>{ this.props.desc.text }</span>
                                <br/>
                                <span><i>{ this.props.desc.location }</i></span>
                            </div>
                        </div>
                        <div className='SplitSlide-Title' style={{...defaultStyles(300, 1000), ...transitionStyles[state]}}>
                            { this.props.title }
                        </div>
                    </div>
                )}
            </Transition>
        )

    }



    render() {

        if(this.props.isMobile) return this.renderMobile()

        const defaultStyles = (duration, delay = 300) => ({
            transition: `opacity ${duration}ms ${delay}ms ease-in`
        })

        const transitionStyles = {
            entering: { opacity: 0 },
            entered: { opacity: 1 },
            exiting: { opacity: 1 },
            exited: { opacity: 0 }
        }

        return super.render(
            <Transition in={this.props.in} timeout={0}>
                { state => (
                    <div className='SplitSlide' style={{background: `url(${this.props.background}) no-repeat 100% fixed / cover`}}>
                        <div className='SplitSlide-Info'>
                            <Disclaimer className='SplitSlide-Disclaimer' style={{...defaultStyles(300, 3000), ...transitionStyles[state]}}/>
                            <div className='SplitSlide-Desc' style={{...defaultStyles(300, 2000), ...transitionStyles[state]}}>
                                <span><b>{ this.props.desc.caption }</b></span>
                                <br/>
                                <span>{ this.props.desc.text }</span>
                                <br/>
                                <span><i>{ this.props.desc.location }</i></span>
                            </div>
                        </div>
                        <div className='SplitSlide-Title' style={{...defaultStyles(300, 1000), ...transitionStyles[state]}}>
                            { this.props.title }
                        </div>
                    </div>
                )}
            </Transition>
        )
    }
}

SplitSlideReverse.propTypes = {
    title: PropTypes.any.isRequired,
    background: PropTypes.string.isRequired,
    desc: PropTypes.any.isRequired,
    isMobile: PropTypes.bool.isRequired
}

const mapStateToProps = ({ isMobile }) => ({ isMobile })

export default connect(mapStateToProps)(SplitSlideReverse)


// WEBPACK FOOTER //
// ./src/components/SplitSlideReverse.js